import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, vModelSelect as _vModelSelect, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "text-left" }
const _hoisted_2 = { class: "content-dashboard" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("hr", null, null, -1)
const _hoisted_4 = { class: "reportes mb-5" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", { class: "reportes__tittle" }, [
  /*#__PURE__*/_createElementVNode("span", null, "Subsystem Codes Manager")
], -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("hr", null, null, -1)
const _hoisted_7 = { class: "reports__section1 tw-justify-center" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("div", { class: "" }, [
  /*#__PURE__*/_createElementVNode("label", { class: "" }, " STATE ")
], -1)
const _hoisted_9 = /*#__PURE__*/_createElementVNode("option", { value: null }, "Select state", -1)
const _hoisted_10 = ["value"]
const _hoisted_11 = { key: 0 }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("div", { class: "" }, [
  /*#__PURE__*/_createElementVNode("label", { class: "" }, " COUNTY ")
], -1)
const _hoisted_13 = /*#__PURE__*/_createElementVNode("option", { value: null }, "Select county", -1)
const _hoisted_14 = ["value"]
const _hoisted_15 = /*#__PURE__*/_createElementVNode("hr", null, null, -1)
const _hoisted_16 = {
  key: 0,
  class: "codes__section mt-3 pb-3"
}
const _hoisted_17 = {
  key: 0,
  class: "text-center p-4"
}
const _hoisted_18 = /*#__PURE__*/_createElementVNode("div", {
  class: "spinner-border",
  role: "status"
}, [
  /*#__PURE__*/_createElementVNode("span", { class: "sr-only" }, "Loading...")
], -1)
const _hoisted_19 = /*#__PURE__*/_createElementVNode("p", { class: "mt-2" }, "Loading codes...", -1)
const _hoisted_20 = [
  _hoisted_18,
  _hoisted_19
]
const _hoisted_21 = { key: 1 }
const _hoisted_22 = { class: "row" }
const _hoisted_23 = { class: "col-md-8" }
const _hoisted_24 = { class: "bg-white p-3 rounded-4 shadow-sm" }
const _hoisted_25 = /*#__PURE__*/_createElementVNode("div", { class: "d-flex justify-content-between align-items-center mb-3" }, [
  /*#__PURE__*/_createElementVNode("h6", { class: "mb-0" }, "Subsystem Codes")
], -1)
const _hoisted_26 = {
  key: 0,
  class: "codes-grid"
}
const _hoisted_27 = { class: "row" }
const _hoisted_28 = { class: "border rounded p-2 text-center bg-light" }
const _hoisted_29 = {
  key: 1,
  class: "text-center py-4"
}
const _hoisted_30 = { class: "mb-0" }
const _hoisted_31 = /*#__PURE__*/_createElementVNode("small", null, "Add the first code using the button on the right", -1)
const _hoisted_32 = { class: "col-md-4" }
const _hoisted_33 = { class: "bg-white p-3 rounded-4 shadow-sm" }
const _hoisted_34 = { class: "mb-3" }
const _hoisted_35 = { class: "mb-1" }
const _hoisted_36 = /*#__PURE__*/_createElementVNode("strong", null, "State:", -1)
const _hoisted_37 = { class: "mb-1" }
const _hoisted_38 = /*#__PURE__*/_createElementVNode("strong", null, "County:", -1)
const _hoisted_39 = ["disabled"]
const _hoisted_40 = {
  key: 0,
  class: "spinner-border spinner-border-sm me-2",
  role: "status"
}
const _hoisted_41 = {
  key: 0,
  class: "mt-3"
}
const _hoisted_42 = { class: "" }
const _hoisted_43 = /*#__PURE__*/_createElementVNode("br", null, null, -1)

import { ref, onMounted, computed } from 'vue';
import TopBar from '@/components/admin/TopBar.vue';
import axios from 'axios';
import { environment } from "@/environment";
import { useToast } from "@/composables/useToast";


export default /*#__PURE__*/_defineComponent({
  __name: 'dataReport',
  setup(__props) {

const toast = useToast();
const loading = ref(false);
const adding = ref(false);
const state = ref(null);
const county = ref(null);
const listStates = ref(null);
const listCounties = ref([]);
const codesList = ref([]);
const url = environment.URL_API;

const sortedCodes = computed(() => {
  return [...codesList.value].sort((a, b) => parseInt(a) - parseInt(b));
});

const firstCode = computed(() => {
  return sortedCodes.value.length > 0 ? sortedCodes.value[0] : null;
});

const lastCode = computed(() => {
  return sortedCodes.value.length > 0 ? sortedCodes.value[sortedCodes.value.length - 1] : null;
});

const nextCode = computed(() => {
  if (codesList.value.length === 0) {
    return "101"; 
  }
  const lastCodeNum = parseInt(lastCode.value);
  return (lastCodeNum + 1).toString();
});

const getStates = async () => {
  loading.value = true;
  try {
    const response = await axios(
      `${url}realtor-format/get-states`,
      {
        method: "GET",
      }
    );
    if (response.data.success) {
      listStates.value = response.data.states;
    } else {
      toast.error("Error loading states", {
        position: "top-end",
        timer: 3000,
        showCloseButton: true,
      });
    }
  } catch (error) {
    toast.error("Error loading states", {
      position: "top-end",
      timer: 3000,
      showCloseButton: true,
    });
    console.error("Error:", error);
  } finally {
    loading.value = false;
  }
};

const getCountiesByState = async () => {
  if (!state.value || state.value === null) {
    listCounties.value = [];
    county.value = null;
    codesList.value = [];
    return;
  }
  loading.value = true;
  try {
    const response = await axios(
      `${url}realtor-format/get-county?state=${state.value.state}`,
      {
        method: "GET",
      }
    );
    if (response.data.success) {
      listCounties.value = response.data.county;
      county.value = null; 
      codesList.value = [];
    } else {
      toast.error("Error loading counties", {
        position: "top-end",
        timer: 3000,
        showCloseButton: true,
      });
    }
  } catch (error) {
    toast.error("Error loading counties", {
      position: "top-end",
      timer: 3000,
      showCloseButton: true,
    });
    console.error("Error:", error);
  } finally {
    loading.value = false;
  }
};

const loadCodes = async () => {
  if (!county.value || county.value === null || !state.value) {
    codesList.value = [];
    return;
  }

  loading.value = true;
  try {
    const response = await axios({
      method: "GET",
      url: `${url}realtor-format/get-codes`,
      params: {
        county: county.value.county,
        state: state.value.state
      }
    });

    if (response.data.success && response.data.codes) {
      codesList.value = response.data.codes;
    } else {
      codesList.value = [];
    }
  } catch (error) {
    toast.error("Error loading codes", {
      position: "top-end",
      timer: 3000,
      showCloseButton: true,
    });
    console.error("Error:", error);
    codesList.value = [];
  } finally {
    loading.value = false;
  }
};

const addNewCode = async () => {
  if (!county.value || !state.value || !nextCode.value) {
    toast.error("Missing required information", {
      position: "top-end",
      timer: 3000,
      showCloseButton: true,
    });
    return;
  }

  adding.value = true;
  try {
    const response = await axios({
      method: "POST",
      url: `${url}realtor-format/add-code`,
      data: {
        state: state.value.state,
        county: county.value.county,
        code: nextCode.value
      }
    });

    if (response.data.success) {
      await toast.success(response.data.message, {
      position: "top-end",
      timer: 3000,
      showCloseButton: true,
    });
    codesList.value.push(nextCode.value);
    } else {
      await toast.error(response.data.message || "Error adding code", {
        position: "top-end",
        timer: 3000,
        showCloseButton: true,
      });
    }
  } catch (error) {
    await toast.error("Error adding new code", {
      position: "top-end",
      timer: 3000,
      showCloseButton: true,
    });
    console.error("Error:", error);
  } finally {
    adding.value = false;
  }
};

onMounted(() => {
  getStates();
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", null, [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(TopBar),
        _hoisted_3,
        _createElementVNode("div", _hoisted_4, [
          _hoisted_5,
          _hoisted_6,
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("div", null, [
              _hoisted_8,
              _withDirectives((_openBlock(), _createElementBlock("select", {
                class: "form-select form-select-sm rounded-pill border-light shadow-sm px-3 py-2",
                style: {"width":"150px"},
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((state).value = $event)),
                onChange: getCountiesByState,
                key: 'state-select'
              }, [
                _hoisted_9,
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(listStates.value, (state) => {
                  return (_openBlock(), _createElementBlock("option", {
                    key: state.state,
                    value: state
                  }, _toDisplayString(state.state), 9, _hoisted_10))
                }), 128))
              ], 32)), [
                [_vModelSelect, state.value]
              ])
            ]),
            (state.value !== null)
              ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                  _hoisted_12,
                  _withDirectives((_openBlock(), _createElementBlock("select", {
                    class: "form-select form-select-sm rounded-pill border-light shadow-sm px-3 py-2",
                    style: {"width":"300px"},
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((county).value = $event)),
                    onChange: loadCodes,
                    key: 'county-select'
                  }, [
                    _hoisted_13,
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(listCounties.value, (county) => {
                      return (_openBlock(), _createElementBlock("option", {
                        key: county.county,
                        value: county
                      }, _toDisplayString(county.county), 9, _hoisted_14))
                    }), 128))
                  ], 32)), [
                    [_vModelSelect, county.value]
                  ])
                ]))
              : _createCommentVNode("", true)
          ]),
          _hoisted_15,
          (county.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                (loading.value)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_17, _hoisted_20))
                  : (_openBlock(), _createElementBlock("div", _hoisted_21, [
                      _createElementVNode("div", _hoisted_22, [
                        _createElementVNode("div", _hoisted_23, [
                          _createElementVNode("div", _hoisted_24, [
                            _hoisted_25,
                            (codesList.value.length > 0)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_26, [
                                  _createElementVNode("div", _hoisted_27, [
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(codesList.value, (code) => {
                                      return (_openBlock(), _createElementBlock("div", {
                                        key: code,
                                        class: "col-md-3 col-sm-4 col-6 mb-2"
                                      }, [
                                        _createElementVNode("div", _hoisted_28, _toDisplayString(code), 1)
                                      ]))
                                    }), 128))
                                  ])
                                ]))
                              : (_openBlock(), _createElementBlock("div", _hoisted_29, [
                                  _createElementVNode("p", _hoisted_30, "No codes found for " + _toDisplayString(state.value?.state) + ", " + _toDisplayString(county.value?.county), 1),
                                  _hoisted_31
                                ]))
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_32, [
                          _createElementVNode("div", _hoisted_33, [
                            _createElementVNode("div", _hoisted_34, [
                              _createElementVNode("p", _hoisted_35, [
                                _hoisted_36,
                                _createTextVNode(" " + _toDisplayString(state.value?.state), 1)
                              ]),
                              _createElementVNode("p", _hoisted_37, [
                                _hoisted_38,
                                _createTextVNode(" " + _toDisplayString(county.value?.county), 1)
                              ])
                            ]),
                            _createElementVNode("button", {
                              type: "button",
                              class: "btn btn-primary w-100",
                              onClick: _cache[2] || (_cache[2] = ($event: any) => (addNewCode())),
                              disabled: adding.value || !nextCode.value
                            }, [
                              (adding.value)
                                ? (_openBlock(), _createElementBlock("span", _hoisted_40))
                                : _createCommentVNode("", true),
                              _createTextVNode(" " + _toDisplayString(adding.value ? 'Adding...' : `Add Code ${nextCode.value}`), 1)
                            ], 8, _hoisted_39),
                            (codesList.value.length > 0)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_41, [
                                  _createElementVNode("small", _hoisted_42, [
                                    _createTextVNode(" Last code: "),
                                    _createElementVNode("strong", null, _toDisplayString(lastCode.value), 1),
                                    _hoisted_43,
                                    _createTextVNode(" Range: " + _toDisplayString(firstCode.value) + " - " + _toDisplayString(lastCode.value), 1)
                                  ])
                                ]))
                              : _createCommentVNode("", true)
                          ])
                        ])
                      ])
                    ]))
              ]))
            : _createCommentVNode("", true)
        ])
      ])
    ])
  ]))
}
}

})